/** An exact ruble amount; invoice queries prefixed with № remain invoice-only. */
export function matchesOrderAmount(query: string, costKop: number): boolean {
  const value = query.trim().replace(/\s*(?:₽|руб\.?|рублей|рубля|рубль)\s*$/iu, '').trim();
  if (!/^(?:\d+|\d{1,3}(?:[\s\u00a0\u202f]\d{3})+)(?:[.,]\d{1,2})?$/.test(value)) return false;
  const [rubles, fraction = ''] = value.replace(/[\s\u00a0\u202f]/g, '').split(/[.,]/);
  const amount = Number(rubles) * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(amount) && amount === costKop;
}
